/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { ProductsMyLikesListStatus200 } from "../types/ProductsMyLikesList.ts";

function getProductsMyLikesListUrl() {
	const res = { method: "GET", url: `/api/products/my-likes/` as const };

	return res;
}

/**
 * @description Получение списка любимых продуктов пользователя.
 * @summary список любимых продуктов
 * {@link /api/products/my-likes/}
 */
export async function productsMyLikesList(config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<ProductsMyLikesListStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getProductsMyLikesListUrl().url.toString(),
		...requestConfig,
	});

	return res.data;
}
